import dynamic from 'next/dynamic';

const LongformGallery = {
  VariantComponent: dynamic(() =>
    import(/* webpackChunkName: "blazePbVariantLongformGallery" */ './LongformGallery')
  ),
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'longformGallery'
  })
};

export default LongformGallery;
